<template>
    <admin-layout>
        <section class="px-4 md:px-5 py-4 md:py-7 space-y-7">
            <custom-info-header icon="iconoir:whatsapp" title="WhatsApp"
                description="Connect your metad account to use the API">
                <template v-slot:action></template>
            </custom-info-header>

            <article class="mt-10 bg-white p-5 rounded-lg">
                <article class="grid grid-cols-2 gap-5">
                    <article class="col-span-1">
                        <form @submit.stop.prevent="onCreateHandle" class="grid grid-cols-2 gap-x-4 gap-y-3">
                            <div class="col-span-full">
                                <h1 class="font-bold text-md text-gray-800">WhatsApp API Configuration</h1>
                                <p class="text-sm text-gray-600">Fill in the required fields to activate the integration.</p>
                            </div>
                            <div>
                                <custom-input 
                                    id="phone"
                                    placeholder="Phone"
                                    label="Phone"
                                    v-model="configuration.phone"
                                    :validate="validate$.phone"
                                />
                            </div>
                            <div>
                                <custom-input 
                                    id="accountId"
                                    placeholder="Account Id"
                                    label="Account Id"
                                    v-model="configuration.accountId"
                                    :validate="validate$.accountId"
                                />
                            </div>
                            <div class="col-span-full">
                                <custom-input 
                                    id="accountKey"
                                    type="password"
                                    label="Account Key"
                                    placeholder="Account Key"
                                    v-model="configuration.accountKey"
                                    :validate="validate$.accountKey"
                                />
                            </div>
                            <div class="col-span-full">
                                <custom-select
                                        id="brandId"
                                        placeholder="Select a brand"
                                        label="Brand"
                                        :data="brands"
                                        :setLabel="(model) => model.name"
                                        :setCode="(model) => model.id"
                                        v-model="configuration.idBrand"
                                        :isLoading="isBrandLoading"
                                        :validate="validate$.idBrand"
                                    />
                            </div>
                            <div class="col-span-full">
                                <custom-button 
                                    type="submit"
                                    :isLoading="isCreateLoading"
                                    label="Set Up"
                                    class="float-right"
                                    size="xs"
                                />
                            </div>
                        </form>
                    </article>
                    <article class="col-span-1">
                        <article class="border bg-gray-100 rounded-lg">
                            <div class="border-b p-3 bg-gray-200">
                                <h1 class="font-bold text-sm">Run/Debug</h1>
                            </div>
                            <div class="p-3"></div>
                        </article>
                    </article>
                </article>
            </article>
        </section>
    </admin-layout>
</template>

<script setup>
import { onMounted } from "vue";
import { useWhatsappConfiguration } from '@/core/composables/useWhatsappConfiguration'
import { useBrand } from '@/core/composables/useBrand'
import AdminLayout from '@/app/layouts/AdminLayout'
import CustomInput from '@/app/components/CustomInput'
import CustomSelect from '@/app/components/CustomSelect'
import CustomInfoHeader from '@/app/components/CustomInfoHeader'
import CustomButton from "@/app/components/CustomButton"


const {
    validate$,
    configuration,
    isCreateLoading,
    onCreateHandle
} = useWhatsappConfiguration();

const {
    isLoading: isBrandLoading,
    brands,
    getBrands
} = useBrand(); 

onMounted(async () => {
    await getBrands();
})
</script>